
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13334',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13334",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.930",
  "client-types": "static-1.501",
  "data-fetching-client": "static-1.10010",
  "foundations-components": "static-1.8574",
  "foundations-components-legacy": "static-1.1599",
  "foundations-theming": "static-1.4839",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.90",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8397",
  "hub-http-shared-msw-handlers": "static-1.10710",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11851",
  "I18n": "static-7.1681",
  "jasmine-runner": "static-1.6809",
  "marketplace-discovery-studio-lib": "static-1.728",
  "marketplace-storefront-base": "static-1.13397",
  "quartz": "static-1.7529",
  "react-dlb": "static-1.90",
  "react-rhumb": "static-1.17086",
  "reactive-variable-buffer-atom": "static-1.3214",
  "reporting-testing-lib": "static-1.10930",
  "reselect": "static-3.13",
  "settings-ui-lib": "static-1.12883",
  "SharedI18nStrings": "static-1.184",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7702",
  "ui-addon-i18n": "static-1.11508",
  "ui-addon-react-router-dom": "static-1.9892",
  "unified-auth": "static-1.1018",
  "unified-auth-core-lib": "static-1.1300",
  "usage-tracker": "static-1.7673",
  "usage-tracker-core": "static-1.7523",
  "customer-data-property-utils": "static-1.8448",
  "hub-http": "static-1.6572",
  "integrations-lib": "static-1.17180",
  "marketplace-ui-common": "static-1.20846",
  "marketplace-ui-install": "static-1.832",
  "property-management-iframe": "static-1.14240",
  "quartz-config": "static-1.1307",
  "quartz-core": "static-1.6748",
  "quartz-routing": "static-1.959",
  "quick-fetch": "static-1.4159",
  "react": "static-7.199",
  "rpc-client-utils": "static-1.5025",
  "ts-schema": "static-1.4330",
  "ui-universal-auth": "static-1.9504",
  "UIComponents": "static-3.8797",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3806",
  "quartz-webpack": "static-1.3753",
  "bend-plugin-quartz-routing": "static-1.607",
  "ai-components-ui-library": "static-1.9831",
  "codemirror": "static-5.103",
  "foundations-assets": "static-1.5246",
  "pulse": "static-1.992",
  "react-codemirror": "static-1.11003",
  "ui-extensions-preview-lib": "static-1.710",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4843",
  "floating-ui": "static-1.64",
  "foundations-theming-specialty": "static-1.2555",
  "framer-motion": "static-1.80",
  "hs-story-utils": "static-1.9785",
  "react-aria": "static-1.73",
  "react-create-root-preference": "static-1.80",
  "react-select-plus": "static-1.114",
  "react-utils": "static-2.5593",
  "react-virtualized": "static-2.108",
  "StyleGuideUI": "static-3.509",
  "tanstack-table": "static-1.62",
  "trellis-assets": "static-1.2797",
  "ui-fonts": "static-1.1113",
  "ui-images": "static-2.1265",
  "bend-plugin-foundations-theming": "static-1.3322",
  "foundations-theming-base": "static-1.3824",
  "stylex": "static-1.42",
  "HeadJS": "static-2.805",
  "hs-test-utils-bend-plugin": "static-1.3508",
  "msw": "static-1.39",
  "msw-config": "static-1.9",
  "testing-library": "static-1.160",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.92",
  "jasmine": "static-4.4672",
  "ui-addon-video-player": "static-1.9052",
  "ai-rendering-library": "static-1.11199",
  "chirp-fetch": "static-1.2257",
  "connections-embed-lib": "static-1.1589",
  "copilot-toolkit": "static-1.11943",
  "feedback-loader": "static-1.29889",
  "laboratory-lib": "static-3.7513",
  "marketplace-embed": "static-1.23016",
  "marketplace-ui-details": "static-1.10741",
  "marketplace-ui-reviews": "static-1.20801",
  "marketplace-ui-tracking": "static-1.15016",
  "sanitize-text": "static-1.8518",
  "usage-tracker-multi": "static-1.6087",
  "usage-tracker-session-replay": "static-1.5359",
  "wootric-nps": "static-1.7232",
  "quartz-head": "static-1.1194",
  "web-vitals": "static-1.16",
  "apollo-link-hub-http": "static-2.5007",
  "immer": "static-1.102",
  "immerable": "static-1.4505",
  "highcharts": "static-8.112",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2731",
  "reporting-data": "static-1.68997",
  "cssUtils": "static-1.983",
  "flux-actions": "static-1.375",
  "react-colorpicker": "static-2.10575",
  "react-dnd-compat": "static-1.4975",
  "redux-observable": "static-1.76",
  "ReduxMessenger": "static-2.10732",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7663",
  "icons": "static-2.695",
  "marketplace-ui-apps-core": "static-1.19378",
  "storybook-react": "static-1.41",
  "trellis-story-utils": "static-1.4867",
  "foundations-components-test-utils": "static-1.6057",
  "quartz-i18n": "static-1.1204",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.568",
  "ads-unified-auth-lib": "static-1.1580",
  "custom-vendor-connection-lib": "static-1.68",
  "google-sheets-integration-lib": "static-1.1130",
  "microsoft-drive-auth-lib": "static-1.268",
  "surveymonkey-integration-lib": "static-1.606",
  "slack-ui-library": "static-1.10758",
  "fsm": "static-1.4114",
  "customer-data-objects": "static-1.8050",
  "property-translator": "static-1.5742",
  "hs-locale-management": "static-1.331",
  "frontend-preferences-client": "static-1.8281",
  "hs-promise-utils": "static-1.5950",
  "hubspot-apollo-client": "static-1.5235",
  "integrations-error-boundary-lib": "static-1.14595",
  "integrations-tracking-lib": "static-1.5971",
  "native-integrations-shared-strings": "static-1.8126",
  "sanitize": "static-1.4831",
  "superstore": "static-1.5120",
  "ui-shepherd-react": "static-3.10632",
  "ai-settings-ui-library": "static-1.8419",
  "hub-http-janus": "static-1.889",
  "hubspotter-http": "static-1.4895",
  "immutable-less": "static-1.5010",
  "marketplace-ui-client-types": "static-1.18253",
  "nav-meta": "static-1.30572",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18453",
  "ui-product-approvals-common": "static-1.1261",
  "ai-studio-lib": "static-1.12523",
  "hubspot-prosemirror": "static-1.19083",
  "integrations-reconnect-lib": "static-1.562",
  "ui-addon-iframeable": "static-1.9438",
  "ui-addon-integrations-directory-panel": "static-2.8377",
  "ui-product-approvals": "static-1.29366",
  "ui-tool-access": "static-1.10515",
  "inbound-db-properties-service-client": "static-1.4083",
  "property-management-common": "static-1.6528",
  "opentelemetry-fe-types": "static-1.142",
  "dispatcher": "static-1.144",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.585",
  "module-federation": "static-1.34",
  "opentelemetry-fe": "static-1.517",
  "quartz-auth": "static-1.1204",
  "quartz-test": "static-1.1204",
  "quartz-tracking": "static-1.908",
  "trellis-components": "static-1.2816",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.435",
  "HubStyle": "static-2.12158",
  "bender-build-tools": "static-1.3452",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23302",
  "ContentUtils": "static-1.69237",
  "customer-data-objects-ui-components": "static-1.13391",
  "sassPrefix": "static-1.250",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.495",
  "batch-promise": "static-1.1905",
  "event-emitter": "static-1.1318",
  "fast-json-patch": "static-1.71",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5799",
  "magpie-types": "static-1.5259",
  "stylex-utils": "static-1.149",
  "trellis-theming": "static-1.1335",
  "avatar-components": "static-1.2844",
  "breeze-engine-core": "static-1.1160",
  "breeze-onboarding-components": "static-1.839",
  "customer-data-filters-ui": "static-1.41082",
  "customer-data-reference-ui-components": "static-1.13529",
  "embedded-academy-lib": "static-1.15689",
  "ExportDialog": "static-6.10740",
  "global-styles-ai-lib": "static-1.250",
  "highlight.js": "static-1.87",
  "marketplace-embed-ba": "static-1.719",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42167",
  "reporting-snowflake": "static-1.57613",
  "reporting-ui-components": "static-2.66266",
  "reporting-visualizations": "static-1.61071",
  "trial-components-library": "static-1.14200",
  "ui-addon-teams": "static-1.21963",
  "upgrade-components-lib": "static-1.590",
  "navigation-components": "static-1.18935",
  "breeze-engine-lib": "static-1.1882",
  "simple-logging-lib": "static-1.3410",
  "nudge-client-utils": "static-1.3230",
  "fail-safe": "static-1.317",
  "app-governance-lib": "static-1.2490",
  "developer-experience-shared-components": "static-1.10897",
  "purchase-motions-components": "static-1.6487",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10460",
  "usage-tracker-anonymous": "static-1.6090",
  "usage-tracker-public": "static-1.7484",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.4062",
  "reference-resolvers": "static-1.8542",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4277",
  "hubspot-apollo-cache": "static-1.694",
  "universal-page-editor-lib": "static-1.3371",
  "final-form": "static-1.79",
  "redux-toolkit": "static-1.79",
  "simple-data-table": "static-1.3613",
  "merchandise-lib": "static-1.279",
  "ui-addon-draggable": "static-3.5107",
  "content-assistance-lib": "static-1.8274",
  "content-media-capture": "static-1.5560",
  "customer-data-ui-utilities": "static-1.10191",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24620",
  "growth-payments-core": "static-1.26292",
  "knowledge-content-types": "static-1.8699",
  "PatternValidationJS": "static-1.3251",
  "payment-link-components": "static-1.24247",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20389",
  "ui-addon-emoji-picker": "static-1.10231",
  "ui-business-units-lib": "static-1.9452",
  "video-components-external": "static-1.12242",
  "video-data-lib": "static-1.35900",
  "navigation-messaging": "static-1.8262",
  "collaboration-sidebar": "static-1.58828",
  "crm-component-utils": "static-1.39951",
  "crm-properties-common-lib": "static-1.6250",
  "customer-data-properties": "static-1.52753",
  "external-options-client-types": "static-1.4377",
  "framework-data-schema-resolvers": "static-1.7254",
  "property-value-citations": "static-1.3367",
  "reference-resolvers-lite": "static-1.8463",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.66",
  "hubspotter-http-shared-msw-handlers": "static-1.10708",
  "base-ui": "static-1.23",
  "react-day-picker": "static-1.11",
  "tanstack-virtual": "static-1.39",
  "cms-field-types": "static-1.5171",
  "content-icons-ui": "static-1.2410",
  "atom": "static-1.5441",
  "idb-keyval": "static-1.52",
  "reactive-lib": "static-1.1079",
  "breeze-artifacts-sdk": "static-1.539",
  "getting-started-shared-tasks": "static-1.19350",
  "onboarding-journeys-lib": "static-1.1039",
  "onboarding-scopes": "static-1.6813",
  "conversations-skeleton-state": "static-1.7596",
  "crm-message-bus": "static-1.43875",
  "customer-data-filters-ui-msw-helpers": "static-1.23517",
  "events-data-lib": "static-1.608",
  "FormUrlGenerator": "static-2.5075",
  "framework-builder-read-service-client": "static-1.4258",
  "hs-resources": "static-1.553",
  "multi-account-reference-resolvers": "static-1.1367",
  "onboarding-tours": "static-1.17215",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14561",
  "segments-client-types": "static-1.11741",
  "academy-common-lib": "static-1.15149",
  "dashboard-lib": "static-1.83003",
  "hubspot-prosemirror-plugins": "static-1.19075",
  "share-with-third-party-component-lib": "static-1.9070",
  "ui-asset-management-lib": "static-1.11464",
  "user-context": "static-1.5471",
  "reporting-plugins": "static-1.10834",
  "reporting-reports": "static-1.68673",
  "hubs-service-types": "static-1.1621",
  "purchase-motions-api": "static-1.6490",
  "salesImages": "static-1.622",
  "signup-constants": "static-1.19716",
  "nest": "static-1.596",
  "breeze-engine-chat-components": "static-1.860",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.2987",
  "nudge-renderer-utils": "static-1.3306",
  "whisper-core-api": "static-1.7429",
  "bend-plugin-fail-safe": "static-1.268",
  "framework-listing-lib": "static-2.29603",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31528",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4594",
  "signup-ui-url-generator": "static-2.8419",
  "onboarding-tours-client": "static-1.5430",
  "one-click-checkout": "static-1.538",
  "platform-infra-nav-components": "static-1.7931",
  "subscription-experience-data-types": "static-1.15302",
  "crm-record-cards-service-types": "static-1.3803",
  "location-customization-utils-lib": "static-1.10212",
  "redux-thunk": "static-2.81",
  "react-flip-move": "static-1.79",
  "ui-coaching-tips": "static-1.29408",
  "content-media-composition-data-lib": "static-1.13364",
  "fix-webm-duration": "static-1.31",
  "notification-sounds": "static-1.4784",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.822",
  "ui-addon-opt": "static-4.8715",
  "commerce-tours-lib": "static-1.6703",
  "growth-onboarding-reliability": "static-1.5442",
  "sales-checkout-service-client": "static-1.3890",
  "data-token-picker": "static-1.16965",
  "FileManagerLib": "static-1.40260",
  "content-media-compositions": "static-2.17371",
  "media-bridge-lib": "static-1.19481",
  "chatspot-widget-iframe": "static-1.23293",
  "collaboration-sidebar-common": "static-1.3625",
  "marketing-platform-lib": "static-1.7233",
  "card-properties-lib": "static-1.45116",
  "commerce-subscription-lib": "static-1.37892",
  "crm-actions": "static-1.6710",
  "crm-cards-sdk": "static-1.44720",
  "customer-data-properties-shared-msw-handlers": "static-1.10037",
  "customer-data-tracking": "static-1.7230",
  "calling-global-api": "static-1.65813",
  "calling-internal-common": "static-1.31682",
  "calling-lifecycle-internal": "static-1.67195",
  "calling-lifecycle-messages": "static-1.59489",
  "commerce-products-lib": "static-1.10656",
  "conditional-properties-service-client": "static-1.4053",
  "crm-index-visualization-core": "static-1.4607",
  "crm-links": "static-1.6660",
  "crm-pipelines-api-client-types": "static-1.4384",
  "formula-editor": "static-1.14855",
  "google-libphonenumber": "static-1.46",
  "inbounddb-objects-service-types": "static-1.4461",
  "meetings-icalendar-utils-lib": "static-1.995",
  "multi-currency-client-types": "static-1.3944",
  "object-builder-ui-client": "static-1.49801",
  "pipeline-validation-client-types": "static-1.4219",
  "smart-data-capture-core": "static-1.233",
  "smart-property-lib": "static-1.8414",
  "tiered-pricing": "static-1.2048",
  "topics-actions-lib": "static-1.531",
  "ui-addon-form-validation": "static-1.11332",
  "zustand": "static-1.86",
  "fdsr-migration-layer": "static-1.373",
  "framework-data-schema-quick-fetch": "static-1.7159",
  "restore-request-side-panel-lib": "static-1.1784",
  "growth-data-modal": "static-1.5971",
  "growth-onboarding-confetti": "static-1.3425",
  "growth-onboarding-next-action-utils": "static-1.2788",
  "onboarding-tours-utils": "static-1.1282",
  "ui-shepherd-tracker": "static-1.8013",
  "crm-index-associations-lib": "static-1.6806",
  "academy-service-client": "static-1.4052",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40119",
  "SafeStorage": "static-1.4754",
  "video-embed": "static-1.36734",
  "redux-actions": "static-3.71",
  "EmailSignatureEditor": "static-1.25073",
  "viral-links-lib": "static-1.7435",
  "nested-table": "static-1.596",
  "timezone-utils": "static-2.5592",
  "getting-started-shared-tasks-store": "static-1.18468",
  "campaign-roi-lib": "static-1.10508",
  "campaigns-utils-lib": "static-1.3588",
  "ui-addon-calendars": "static-2.5708",
  "customer-data-views-management": "static-1.26127",
  "framework-data-table": "static-2.12649",
  "nudge-custom-ui-functions": "static-1.1578",
  "switchboard-lib": "static-1.582",
  "access-check-ui-lib": "static-1.1689",
  "app-users-service-client": "static-1.5980",
  "app-users-service-types": "static-1.5388",
  "mini-checkout-client": "static-1.27633",
  "onboarding-utils": "static-1.5731",
  "permissions-shared-i18n-strings-fe": "static-1.2137",
  "ui-coaching-tips-shared-config": "static-1.29393",
  "checkout-sdk": "static-3.24476",
  "payment-method-components": "static-1.7206",
  "touchless-buying-components": "static-1.6344",
  "upgrade-catalog-service-types": "static-1.3796",
  "edison-service-client-types": "static-1.758",
  "growth-onboarding-feedback-components": "static-1.6946",
  "audio-components": "static-1.6421",
  "FileManagerImages": "static-1.37771",
  "video-components": "static-1.14244",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92963",
  "customer-data-sidebar": "static-2.46833",
  "enrichment-lib": "static-1.617",
  "ui-addon-draggable-compat": "static-2.4623",
  "universal-record-utils-lib": "static-1.2116",
  "commerce-billing-lib": "static-1.20317",
  "commerce-shared-components-lib": "static-1.19375",
  "commerce-tools-ui-lib": "static-1.11142",
  "crm-fe-perf": "static-1.23258",
  "calling-error-reporting": "static-1.31689",
  "shared-worker-versioning": "static-1.11401",
  "calling-usage-tracker": "static-1.6896",
  "voice-sms-access-library": "static-1.2177",
  "commerce-permissions": "static-1.1137",
  "products-iframe-lib": "static-1.8688",
  "products-ui-components-shared-msw-handlers": "static-1.11092",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10793",
  "sales-views-client-types": "static-1.4616",
  "bark-lib": "static-1.16882",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.727",
  "policy-lib": "static-1.7166",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10856",
  "onboarding-data-sync-lib": "static-1.2621",
  "growth-onboarding-next-action-components": "static-1.2816",
  "user-context-client": "static-1.4869",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.62",
  "urlinator": "static-1.4877",
  "outpost": "static-1.4500",
  "draft-convert": "static-2.81",
  "draft-extend": "static-3.84",
  "draft-js": "static-5.86",
  "draft-plugins": "static-2.22222",
  "sales-email-signature-service-client": "static-1.4208",
  "ts-utils-lib": "static-1.508",
  "copilot-messaging": "static-1.2193",
  "crm-export-dialog": "static-1.6645",
  "crm-index-ui-shimmer": "static-1.2787",
  "crm-view-components": "static-1.1307",
  "react-beautiful-dnd": "static-1.71",
  "customer-data-associations": "static-1.7690",
  "tasks-actions-lib": "static-1.240",
  "InboxConnectUtils": "static-4.15653",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46947",
  "hub-http-rxjs": "static-1.856",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4352",
  "company-details-components": "static-1.6567",
  "react-performance-metrics-lib": "static-1.914",
  "pricing-pages-ui-components": "static-1.16093",
  "quote-checkout-service-types": "static-1.3815",
  "social-insights-client-types": "static-1.22729",
  "crm_universal": "static-1.22556",
  "customer-data-email": "static-1.18585",
  "card-payment-highlight-lib": "static-1.38102",
  "commerce-contract-lib": "static-1.13513",
  "invoices-highlight-card-lib": "static-1.55915",
  "orders-highlight-card-lib": "static-1.22294",
  "products-highlight-card-lib": "static-1.18939",
  "quotes-highlight-card-lib": "static-1.72880",
  "crm-source-interpretation-lib": "static-1.5692",
  "data-agent-test-utils": "static-1.210",
  "data-agent-utils": "static-1.679",
  "crm-object-search-query-utilities": "static-1.10285",
  "utility-belt": "static-1.2893",
  "payments-enrollment-embed-lib": "static-1.23975",
  "stripe-embedded-components": "static-1.8072",
  "customer-data-rte": "static-1.33723",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6363",
  "payments-post-enroll-local-storage-lib": "static-1.5464",
  "qrcode-generator": "static-1.77",
  "quotes-client-types": "static-1.38970",
  "calling-orchestration-schema": "static-1.36954",
  "react-reducer-toolkit": "static-1.16460",
  "meetings-connect-utils-lib": "static-1.7971",
  "hub-http-contrib": "static-1.3388",
  "ui-addon-sales-email": "static-1.5563",
  "access-control-lib": "static-1.10785",
  "EmailComponents": "static-1.55649",
  "EmailData": "static-1.54327",
  "redux-less": "static-2.9823",
  "company-details-service-types": "static-1.4303",
  "segments-query-core": "static-1.1785",
  "pricing-pages-api": "static-1.15958",
  "sequences-lib": "static-1.8607",
  "ui-gdpr-components": "static-1.10646",
  "products-ui-components": "static-1.41174",
  "accounting-integrations-ui-components": "static-1.7616",
  "invoices-ui-lib": "static-1.55931",
  "commerce-products-api": "static-1.2758",
  "invoices-iframe-lib": "static-1.57989",
  "quotes-modal-lib": "static-1.103558",
  "quotes-ui-lib": "static-1.81601",
  "stripe-connect-js": "static-1.78",
  "draft-content-plugins": "static-1.28979",
  "ContentComponents": "static-2.72193",
  "ContentData": "static-1.69312",
  "marketing-email-service-types": "static-1.2133",
  "messaging-editing-lib": "static-1.47261",
  "messaging-usage-based-billing-components-lib": "static-1.2123",
  "automation-ui-source-apps": "static-1.19785",
  "automation-ui-types": "static-1.20703",
  "messaging-types-lib": "static-1.46998",
  "onboarding-settings-client": "static-1.4869",
  "sequences-client-types-lib": "static-1.8464",
  "commerce-tax-lib": "static-1.899",
  "price-books-api": "static-1.1830",
  "price-books-components": "static-1.1888",
  "property-description-translator": "static-1.4185",
  "ramp-editor": "static-1.982",
  "commerce-analytics-service-client": "static-1.3878",
  "totals-ui-components": "static-1.24384",
  "SalesContentIndexUI": "static-3.9675",
  "advanced-menus-core": "static-1.15650",
  "advanced-menus-lib": "static-1.12507",
  "automation-ui-ubb": "static-1.6619",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7699",
  "data-token-views": "static-1.16946",
  "forms-utils-lib": "static-1.13167",
  "payments-embed-points-lib": "static-1.13677",
  "react-tinymce": "static-1.56077",
  "simple-menus-core": "static-1.15649",
  "simple-menus-lib": "static-1.17166",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55203",
  "tinymce-data": "static-1.41288",
  "tinymce-plugins": "static-1.58317",
  "tinymce-themes": "static-1.57173",
  "ui-brand-identity-lib": "static-1.16677",
  "ui-memberships-settings-lib": "static-1.34941",
  "videoconference-integration-components": "static-1.7368",
  "automation-applications-service-types": "static-1.3665",
  "automation-platform-service-types": "static-1.2676",
  "ContentEditorUI": "static-2.78021",
  "content-whatsapp-service-types": "static-1.584",
  "short-messages-app-service-client": "static-1.4283",
  "web-interactives-components": "static-1.14322",
  "web-interactives-data": "static-1.14323",
  "messaging-shared-utils-lib": "static-1.1572",
  "messaging-user-info-utils-lib": "static-1.1742",
  "email-portal-health-service-types": "static-1.1342",
  "line-items-api": "static-1.1167",
  "commerce-totals-service-types": "static-1.4069",
  "FireAlarmUi": "static-1.4756",
  "sales-templates-service-types-lib": "static-1.4421",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22639",
  "automation-ui-usage-tracking": "static-1.22102",
  "data-studio-ubb": "static-1.3605",
  "interframe": "static-3.5103",
  "layout-dnd-components": "static-1.13048",
  "layout-dnd-utils": "static-1.12023",
  "NamespacedHubStyle": "static-2.9295",
  "campaigns-lib": "static-1.27743",
  "content-management-data-lib": "static-1.6050",
  "copilot-plugins": "static-1.11915",
  "cta-picker": "static-1.37160",
  "customer-agent-discovery-components-lib": "static-1.4066",
  "editor-components": "static-1.13727",
  "editor-iframe-lib": "static-1.8857",
  "error-messaging-js": "static-1.5547",
  "FormsCommonComponents": "static-1.86666",
  "layout-data-lib": "static-1.10348",
  "pictos": "static-7.192",
  "react-transition-group": "static-2.74",
  "redux-request-state": "static-1.10999",
  "SharedLegalStrings": "static-1.2090",
  "smart-content-core": "static-1.43269",
  "smart-content-lib": "static-1.43922",
  "social-composer-lib": "static-1.60394",
  "structured-content-lib": "static-1.26012",
  "theme-previewer-lib": "static-1.53996",
  "tinymce-copilot": "static-1.17271",
  "xray-recommendation-lib": "static-1.8328",
  "automation-ui-routing": "static-1.22060",
  "sql-reporting-client-types": "static-1.5936",
  "attribution-lib": "static-1.42866",
  "reporting-enablement": "static-1.23931",
  "forms-ai-lib": "static-1.4835",
  "codemirror-dlb": "static-1.59580",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6803",
  "report-customization-components": "static-1.14004",
  "data-quality-ui-library": "static-1.14003",
  "reporting-filters": "static-1.1095",
  "reporting-insights-lib": "static-1.2685",
  "merge-modal-lib": "static-1.12759"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13334",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.930",
  "client-types": "/client-types/static-1.501",
  "data-fetching-client": "/data-fetching-client/static-1.10010",
  "foundations-components": "/foundations-components/static-1.8574",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1599",
  "foundations-theming": "/foundations-theming/static-1.4839",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.90",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8397",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10710",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11851",
  "I18n": "/I18n/static-7.1681",
  "jasmine-runner": "/jasmine-runner/static-1.6809",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.728",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13397",
  "quartz": "/quartz/static-1.7529",
  "react-dlb": "/react-dlb/static-1.90",
  "react-rhumb": "/react-rhumb/static-1.17086",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3214",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10930",
  "reselect": "/reselect/static-3.13",
  "settings-ui-lib": "/settings-ui-lib/static-1.12883",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.184",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7702",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11508",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9892",
  "unified-auth": "/unified-auth/static-1.1018",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1300",
  "usage-tracker": "/usage-tracker/static-1.7673",
  "usage-tracker-core": "/usage-tracker-core/static-1.7523",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8448",
  "hub-http": "/hub-http/static-1.6572",
  "integrations-lib": "/integrations-lib/static-1.17180",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20846",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.832",
  "property-management-iframe": "/property-management-iframe/static-1.14240",
  "quartz-config": "/quartz-config/static-1.1307",
  "quartz-core": "/quartz-core/static-1.6748",
  "quartz-routing": "/quartz-routing/static-1.959",
  "quick-fetch": "/quick-fetch/static-1.4159",
  "react": "/react/static-7.199",
  "rpc-client-utils": "/rpc-client-utils/static-1.5025",
  "ts-schema": "/ts-schema/static-1.4330",
  "ui-universal-auth": "/ui-universal-auth/static-1.9504",
  "UIComponents": "/UIComponents/static-3.8797",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3806",
  "quartz-webpack": "/quartz-webpack/static-1.3753",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.607",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9831",
  "codemirror": "/codemirror/static-5.103",
  "foundations-assets": "/foundations-assets/static-1.5246",
  "pulse": "/pulse/static-1.992",
  "react-codemirror": "/react-codemirror/static-1.11003",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.710",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4843",
  "floating-ui": "/floating-ui/static-1.64",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2555",
  "framer-motion": "/framer-motion/static-1.80",
  "hs-story-utils": "/hs-story-utils/static-1.9785",
  "react-aria": "/react-aria/static-1.73",
  "react-create-root-preference": "/react-create-root-preference/static-1.80",
  "react-select-plus": "/react-select-plus/static-1.114",
  "react-utils": "/react-utils/static-2.5593",
  "react-virtualized": "/react-virtualized/static-2.108",
  "StyleGuideUI": "/StyleGuideUI/static-3.509",
  "tanstack-table": "/tanstack-table/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.2797",
  "ui-fonts": "/ui-fonts/static-1.1113",
  "ui-images": "/ui-images/static-2.1265",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3322",
  "foundations-theming-base": "/foundations-theming-base/static-1.3824",
  "stylex": "/stylex/static-1.42",
  "HeadJS": "/HeadJS/static-2.805",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3508",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.9",
  "testing-library": "/testing-library/static-1.160",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.92",
  "jasmine": "/jasmine/static-4.4672",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9052",
  "ai-rendering-library": "/ai-rendering-library/static-1.11199",
  "chirp-fetch": "/chirp-fetch/static-1.2257",
  "connections-embed-lib": "/connections-embed-lib/static-1.1589",
  "copilot-toolkit": "/copilot-toolkit/static-1.11943",
  "feedback-loader": "/feedback-loader/static-1.29889",
  "laboratory-lib": "/laboratory-lib/static-3.7513",
  "marketplace-embed": "/marketplace-embed/static-1.23016",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10741",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20801",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15016",
  "sanitize-text": "/sanitize-text/static-1.8518",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6087",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5359",
  "wootric-nps": "/wootric-nps/static-1.7232",
  "quartz-head": "/quartz-head/static-1.1194",
  "web-vitals": "/web-vitals/static-1.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5007",
  "immer": "/immer/static-1.102",
  "immerable": "/immerable/static-1.4505",
  "highcharts": "/highcharts/static-8.112",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2731",
  "reporting-data": "/reporting-data/static-1.68997",
  "cssUtils": "/cssUtils/static-1.983",
  "flux-actions": "/flux-actions/static-1.375",
  "react-colorpicker": "/react-colorpicker/static-2.10575",
  "react-dnd-compat": "/react-dnd-compat/static-1.4975",
  "redux-observable": "/redux-observable/static-1.76",
  "ReduxMessenger": "/ReduxMessenger/static-2.10732",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7663",
  "icons": "/icons/static-2.695",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19378",
  "storybook-react": "/storybook-react/static-1.41",
  "trellis-story-utils": "/trellis-story-utils/static-1.4867",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6057",
  "quartz-i18n": "/quartz-i18n/static-1.1204",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.568",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1580",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.68",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1130",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.268",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.606",
  "slack-ui-library": "/slack-ui-library/static-1.10758",
  "fsm": "/fsm/static-1.4114",
  "customer-data-objects": "/customer-data-objects/static-1.8050",
  "property-translator": "/property-translator/static-1.5742",
  "hs-locale-management": "/hs-locale-management/static-1.331",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8281",
  "hs-promise-utils": "/hs-promise-utils/static-1.5950",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5235",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14595",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5971",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8126",
  "sanitize": "/sanitize/static-1.4831",
  "superstore": "/superstore/static-1.5120",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10632",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8419",
  "hub-http-janus": "/hub-http-janus/static-1.889",
  "hubspotter-http": "/hubspotter-http/static-1.4895",
  "immutable-less": "/immutable-less/static-1.5010",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18253",
  "nav-meta": "/nav-meta/static-1.30572",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18453",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1261",
  "ai-studio-lib": "/ai-studio-lib/static-1.12523",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19083",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.562",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9438",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8377",
  "ui-product-approvals": "/ui-product-approvals/static-1.29366",
  "ui-tool-access": "/ui-tool-access/static-1.10515",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4083",
  "property-management-common": "/property-management-common/static-1.6528",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.142",
  "dispatcher": "/dispatcher/static-1.144",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.585",
  "module-federation": "/module-federation/static-1.34",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.517",
  "quartz-auth": "/quartz-auth/static-1.1204",
  "quartz-test": "/quartz-test/static-1.1204",
  "quartz-tracking": "/quartz-tracking/static-1.908",
  "trellis-components": "/trellis-components/static-1.2816",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.435",
  "HubStyle": "/HubStyle/static-2.12158",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23302",
  "ContentUtils": "/ContentUtils/static-1.69237",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13391",
  "sassPrefix": "/sassPrefix/static-1.250",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.495",
  "batch-promise": "/batch-promise/static-1.1905",
  "event-emitter": "/event-emitter/static-1.1318",
  "fast-json-patch": "/fast-json-patch/static-1.71",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5799",
  "magpie-types": "/magpie-types/static-1.5259",
  "stylex-utils": "/stylex-utils/static-1.149",
  "trellis-theming": "/trellis-theming/static-1.1335",
  "avatar-components": "/avatar-components/static-1.2844",
  "breeze-engine-core": "/breeze-engine-core/static-1.1160",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.839",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41082",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13529",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15689",
  "ExportDialog": "/ExportDialog/static-6.10740",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.250",
  "highlight.js": "/highlight.js/static-1.87",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.719",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42167",
  "reporting-snowflake": "/reporting-snowflake/static-1.57613",
  "reporting-ui-components": "/reporting-ui-components/static-2.66266",
  "reporting-visualizations": "/reporting-visualizations/static-1.61071",
  "trial-components-library": "/trial-components-library/static-1.14200",
  "ui-addon-teams": "/ui-addon-teams/static-1.21963",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.590",
  "navigation-components": "/navigation-components/static-1.18935",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1882",
  "simple-logging-lib": "/simple-logging-lib/static-1.3410",
  "nudge-client-utils": "/nudge-client-utils/static-1.3230",
  "fail-safe": "/fail-safe/static-1.317",
  "app-governance-lib": "/app-governance-lib/static-1.2490",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10897",
  "purchase-motions-components": "/purchase-motions-components/static-1.6487",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10460",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6090",
  "usage-tracker-public": "/usage-tracker-public/static-1.7484",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.4062",
  "reference-resolvers": "/reference-resolvers/static-1.8542",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4277",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.694",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3371",
  "final-form": "/final-form/static-1.79",
  "redux-toolkit": "/redux-toolkit/static-1.79",
  "simple-data-table": "/simple-data-table/static-1.3613",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5107",
  "content-assistance-lib": "/content-assistance-lib/static-1.8274",
  "content-media-capture": "/content-media-capture/static-1.5560",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10191",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24620",
  "growth-payments-core": "/growth-payments-core/static-1.26292",
  "knowledge-content-types": "/knowledge-content-types/static-1.8699",
  "PatternValidationJS": "/PatternValidationJS/static-1.3251",
  "payment-link-components": "/payment-link-components/static-1.24247",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20389",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10231",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9452",
  "video-components-external": "/video-components-external/static-1.12242",
  "video-data-lib": "/video-data-lib/static-1.35900",
  "navigation-messaging": "/navigation-messaging/static-1.8262",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58828",
  "crm-component-utils": "/crm-component-utils/static-1.39951",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6250",
  "customer-data-properties": "/customer-data-properties/static-1.52753",
  "external-options-client-types": "/external-options-client-types/static-1.4377",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7254",
  "property-value-citations": "/property-value-citations/static-1.3367",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8463",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.66",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10708",
  "base-ui": "/base-ui/static-1.23",
  "react-day-picker": "/react-day-picker/static-1.11",
  "tanstack-virtual": "/tanstack-virtual/static-1.39",
  "cms-field-types": "/cms-field-types/static-1.5171",
  "content-icons-ui": "/content-icons-ui/static-1.2410",
  "atom": "/atom/static-1.5441",
  "idb-keyval": "/idb-keyval/static-1.52",
  "reactive-lib": "/reactive-lib/static-1.1079",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.539",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19350",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1039",
  "onboarding-scopes": "/onboarding-scopes/static-1.6813",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7596",
  "crm-message-bus": "/crm-message-bus/static-1.43875",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23517",
  "events-data-lib": "/events-data-lib/static-1.608",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5075",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4258",
  "hs-resources": "/hs-resources/static-1.553",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1367",
  "onboarding-tours": "/onboarding-tours/static-1.17215",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14561",
  "segments-client-types": "/segments-client-types/static-1.11741",
  "academy-common-lib": "/academy-common-lib/static-1.15149",
  "dashboard-lib": "/dashboard-lib/static-1.83003",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19075",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9070",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11464",
  "user-context": "/user-context/static-1.5471",
  "reporting-plugins": "/reporting-plugins/static-1.10834",
  "reporting-reports": "/reporting-reports/static-1.68673",
  "hubs-service-types": "/hubs-service-types/static-1.1621",
  "purchase-motions-api": "/purchase-motions-api/static-1.6490",
  "salesImages": "/salesImages/static-1.622",
  "signup-constants": "/signup-constants/static-1.19716",
  "nest": "/nest/static-1.596",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.860",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2987",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3306",
  "whisper-core-api": "/whisper-core-api/static-1.7429",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.268",
  "framework-listing-lib": "/framework-listing-lib/static-2.29603",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31528",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4594",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8419",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5430",
  "one-click-checkout": "/one-click-checkout/static-1.538",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7931",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15302",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3803",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10212",
  "redux-thunk": "/redux-thunk/static-2.81",
  "react-flip-move": "/react-flip-move/static-1.79",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29408",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13364",
  "fix-webm-duration": "/fix-webm-duration/static-1.31",
  "notification-sounds": "/notification-sounds/static-1.4784",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.822",
  "ui-addon-opt": "/ui-addon-opt/static-4.8715",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6703",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5442",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3890",
  "data-token-picker": "/data-token-picker/static-1.16965",
  "FileManagerLib": "/FileManagerLib/static-1.40260",
  "content-media-compositions": "/content-media-compositions/static-2.17371",
  "media-bridge-lib": "/media-bridge-lib/static-1.19481",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23293",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3625",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7233",
  "card-properties-lib": "/card-properties-lib/static-1.45116",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37892",
  "crm-actions": "/crm-actions/static-1.6710",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44720",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10037",
  "customer-data-tracking": "/customer-data-tracking/static-1.7230",
  "calling-global-api": "/calling-global-api/static-1.65813",
  "calling-internal-common": "/calling-internal-common/static-1.31682",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67195",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59489",
  "commerce-products-lib": "/commerce-products-lib/static-1.10656",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4053",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4607",
  "crm-links": "/crm-links/static-1.6660",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4384",
  "formula-editor": "/formula-editor/static-1.14855",
  "google-libphonenumber": "/google-libphonenumber/static-1.46",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4461",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.995",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3944",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49801",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4219",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.233",
  "smart-property-lib": "/smart-property-lib/static-1.8414",
  "tiered-pricing": "/tiered-pricing/static-1.2048",
  "topics-actions-lib": "/topics-actions-lib/static-1.531",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11332",
  "zustand": "/zustand/static-1.86",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.373",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7159",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1784",
  "growth-data-modal": "/growth-data-modal/static-1.5971",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3425",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2788",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1282",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8013",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6806",
  "academy-service-client": "/academy-service-client/static-1.4052",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40119",
  "SafeStorage": "/SafeStorage/static-1.4754",
  "video-embed": "/video-embed/static-1.36734",
  "redux-actions": "/redux-actions/static-3.71",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25073",
  "viral-links-lib": "/viral-links-lib/static-1.7435",
  "nested-table": "/nested-table/static-1.596",
  "timezone-utils": "/timezone-utils/static-2.5592",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18468",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10508",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3588",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5708",
  "customer-data-views-management": "/customer-data-views-management/static-1.26127",
  "framework-data-table": "/framework-data-table/static-2.12649",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1578",
  "switchboard-lib": "/switchboard-lib/static-1.582",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1689",
  "app-users-service-client": "/app-users-service-client/static-1.5980",
  "app-users-service-types": "/app-users-service-types/static-1.5388",
  "mini-checkout-client": "/mini-checkout-client/static-1.27633",
  "onboarding-utils": "/onboarding-utils/static-1.5731",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2137",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29393",
  "checkout-sdk": "/checkout-sdk/static-3.24476",
  "payment-method-components": "/payment-method-components/static-1.7206",
  "touchless-buying-components": "/touchless-buying-components/static-1.6344",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3796",
  "edison-service-client-types": "/edison-service-client-types/static-1.758",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6946",
  "audio-components": "/audio-components/static-1.6421",
  "FileManagerImages": "/FileManagerImages/static-1.37771",
  "video-components": "/video-components/static-1.14244",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92963",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46833",
  "enrichment-lib": "/enrichment-lib/static-1.617",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4623",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2116",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20317",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19375",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11142",
  "crm-fe-perf": "/crm-fe-perf/static-1.23258",
  "calling-error-reporting": "/calling-error-reporting/static-1.31689",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11401",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6896",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2177",
  "commerce-permissions": "/commerce-permissions/static-1.1137",
  "products-iframe-lib": "/products-iframe-lib/static-1.8688",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11092",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10793",
  "sales-views-client-types": "/sales-views-client-types/static-1.4616",
  "bark-lib": "/bark-lib/static-1.16882",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.727",
  "policy-lib": "/policy-lib/static-1.7166",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10856",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2621",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2816",
  "user-context-client": "/user-context-client/static-1.4869",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.62",
  "urlinator": "/urlinator/static-1.4877",
  "outpost": "/outpost/static-1.4500",
  "draft-convert": "/draft-convert/static-2.81",
  "draft-extend": "/draft-extend/static-3.84",
  "draft-js": "/draft-js/static-5.86",
  "draft-plugins": "/draft-plugins/static-2.22222",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4208",
  "ts-utils-lib": "/ts-utils-lib/static-1.508",
  "copilot-messaging": "/copilot-messaging/static-1.2193",
  "crm-export-dialog": "/crm-export-dialog/static-1.6645",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2787",
  "crm-view-components": "/crm-view-components/static-1.1307",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.71",
  "customer-data-associations": "/customer-data-associations/static-1.7690",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.240",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15653",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46947",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.856",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4352",
  "company-details-components": "/company-details-components/static-1.6567",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.914",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16093",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3815",
  "social-insights-client-types": "/social-insights-client-types/static-1.22729",
  "crm_universal": "/crm_universal/static-1.22556",
  "customer-data-email": "/customer-data-email/static-1.18585",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38102",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13513",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55915",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22294",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18939",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72880",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5692",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.210",
  "data-agent-utils": "/data-agent-utils/static-1.679",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10285",
  "utility-belt": "/utility-belt/static-1.2893",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23975",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8072",
  "customer-data-rte": "/customer-data-rte/static-1.33723",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6363",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5464",
  "qrcode-generator": "/qrcode-generator/static-1.77",
  "quotes-client-types": "/quotes-client-types/static-1.38970",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36954",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16460",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7971",
  "hub-http-contrib": "/hub-http-contrib/static-1.3388",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5563",
  "access-control-lib": "/access-control-lib/static-1.10785",
  "EmailComponents": "/EmailComponents/static-1.55649",
  "EmailData": "/EmailData/static-1.54327",
  "redux-less": "/redux-less/static-2.9823",
  "company-details-service-types": "/company-details-service-types/static-1.4303",
  "segments-query-core": "/segments-query-core/static-1.1785",
  "pricing-pages-api": "/pricing-pages-api/static-1.15958",
  "sequences-lib": "/sequences-lib/static-1.8607",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10646",
  "products-ui-components": "/products-ui-components/static-1.41174",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7616",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55931",
  "commerce-products-api": "/commerce-products-api/static-1.2758",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57989",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103558",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81601",
  "stripe-connect-js": "/stripe-connect-js/static-1.78",
  "draft-content-plugins": "/draft-content-plugins/static-1.28979",
  "ContentComponents": "/ContentComponents/static-2.72193",
  "ContentData": "/ContentData/static-1.69312",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2133",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47261",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2123",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19785",
  "automation-ui-types": "/automation-ui-types/static-1.20703",
  "messaging-types-lib": "/messaging-types-lib/static-1.46998",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4869",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8464",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.899",
  "price-books-api": "/price-books-api/static-1.1830",
  "price-books-components": "/price-books-components/static-1.1888",
  "property-description-translator": "/property-description-translator/static-1.4185",
  "ramp-editor": "/ramp-editor/static-1.982",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3878",
  "totals-ui-components": "/totals-ui-components/static-1.24384",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9675",
  "advanced-menus-core": "/advanced-menus-core/static-1.15650",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12507",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6619",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7699",
  "data-token-views": "/data-token-views/static-1.16946",
  "forms-utils-lib": "/forms-utils-lib/static-1.13167",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13677",
  "react-tinymce": "/react-tinymce/static-1.56077",
  "simple-menus-core": "/simple-menus-core/static-1.15649",
  "simple-menus-lib": "/simple-menus-lib/static-1.17166",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55203",
  "tinymce-data": "/tinymce-data/static-1.41288",
  "tinymce-plugins": "/tinymce-plugins/static-1.58317",
  "tinymce-themes": "/tinymce-themes/static-1.57173",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16677",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34941",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7368",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3665",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2676",
  "ContentEditorUI": "/ContentEditorUI/static-2.78021",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.584",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4283",
  "web-interactives-components": "/web-interactives-components/static-1.14322",
  "web-interactives-data": "/web-interactives-data/static-1.14323",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1572",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1742",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1342",
  "line-items-api": "/line-items-api/static-1.1167",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4069",
  "FireAlarmUi": "/FireAlarmUi/static-1.4756",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4421",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22639",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22102",
  "data-studio-ubb": "/data-studio-ubb/static-1.3605",
  "interframe": "/interframe/static-3.5103",
  "layout-dnd-components": "/layout-dnd-components/static-1.13048",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12023",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9295",
  "campaigns-lib": "/campaigns-lib/static-1.27743",
  "content-management-data-lib": "/content-management-data-lib/static-1.6050",
  "copilot-plugins": "/copilot-plugins/static-1.11915",
  "cta-picker": "/cta-picker/static-1.37160",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4066",
  "editor-components": "/editor-components/static-1.13727",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8857",
  "error-messaging-js": "/error-messaging-js/static-1.5547",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86666",
  "layout-data-lib": "/layout-data-lib/static-1.10348",
  "pictos": "/pictos/static-7.192",
  "react-transition-group": "/react-transition-group/static-2.74",
  "redux-request-state": "/redux-request-state/static-1.10999",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2090",
  "smart-content-core": "/smart-content-core/static-1.43269",
  "smart-content-lib": "/smart-content-lib/static-1.43922",
  "social-composer-lib": "/social-composer-lib/static-1.60394",
  "structured-content-lib": "/structured-content-lib/static-1.26012",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53996",
  "tinymce-copilot": "/tinymce-copilot/static-1.17271",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8328",
  "automation-ui-routing": "/automation-ui-routing/static-1.22060",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5936",
  "attribution-lib": "/attribution-lib/static-1.42866",
  "reporting-enablement": "/reporting-enablement/static-1.23931",
  "forms-ai-lib": "/forms-ai-lib/static-1.4835",
  "codemirror-dlb": "/codemirror-dlb/static-1.59580",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6803",
  "report-customization-components": "/report-customization-components/static-1.14004",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.14003",
  "reporting-filters": "/reporting-filters/static-1.1095",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2685",
  "merge-modal-lib": "/merge-modal-lib/static-1.12759"
}
};
